import React from 'react';
import { connect } from 'react-redux';
import { VeritoneApp, FilePickerWidget } from 'veritone-widgets';

import styles from './styles/index.scss';
import { oneOfType, number, string, func, arrayOf } from 'prop-types';
import browseToUpload from 'resources/images/browse-to-upload.png';

import { guid } from 'helpers/misc';
import { bytesToSize } from 'helpers/misc';
import { selectSessionToken } from 'modules/user';
import { getConfig } from 'modules/config';

import withAppConfig from 'shared-components/withAppConfig';

@withAppConfig
@connect((state) => {
  const restApiRoot = getConfig(state).restApiRoot;
  const apiRootUri = restApiRoot.substring(0, restApiRoot.lastIndexOf('/'));
  return {
    sessionToken: selectSessionToken(state),
    apiRootUri,
  };
})
export default class ImageUpload extends React.Component {
  static propTypes = {
    displayImage: string,
    // height/width aspect ratio of image
    width: oneOfType([string, number]).isRequired,
    height: number.isRequired,
    // force picker to be narrower than 100%
    pickerWidth: number,
    onSuccess: func.isRequired,
    onError: func,
    elId: string,
    sessionToken: string,
    apiRootUri: string,
    acceptedFileTypes: oneOfType([string, arrayOf(string)]),
  };
  static defaultProps = {
    elId: `file-picker-${guid()}`,
    acceptedFileTypes: ['image/*'],
  };

  componentDidMount() {
    VeritoneApp({ apiRoot: this.props.apiRootUri }).login({
      sessionToken: this.props.sessionToken,
    });
    this._picker = new FilePickerWidget({
      elId: this.props.elId,
      accept: this.props.acceptedFileTypes,
      allowUrlUpload: false,
    });
  }

  handlePick = () => {
    this._picker.pick(this.handleFileResult);
  };

  handleFileResult = (files, { warning, error, cancelled }) => {
    if (cancelled) {
      return this.handleCancelledPick();
    }

    if (error) {
      return this.handlePickError(error);
    }

    if (warning) {
      this.handlePickWarning(warning);
    }

    this.props.onSuccess({
      name: files[0].fileName,
      url: files[0].getUrl,
      size: bytesToSize(files[0].size),
      type: this.parseFileType(files[0].type),
    });
  };

  handleCancelledPick = () => {
    console.log('Picking was cancelled');
  };

  handlePickError = (error) => {
    console.log('Picking failed with error:', error);
  };

  handlePickWarning = (warning) => {
    console.log('Pick resulted in a warning:', warning);
  };

  parseFileType = (contentType) => contentType.split('/')[1].toUpperCase();

  render() {
    const largerDim = Math.max(this.props.width, this.props.height);
    const smallerDim = Math.min(this.props.width, this.props.height);
    const aspectRatio = smallerDim / largerDim;

    // proportional scale
    // http://stackoverflow.com/questions/1495407/maintain-the-aspect-ratio-of-a-div-with-css
    const paddingNeeded = this.props.pickerWidth
      ? (1 - aspectRatio || 1) * this.props.pickerWidth
      : `${(1 - aspectRatio) * 100 || 100}%`;

    return (
      <React.Fragment>
        <div
          className={styles['container']}
          style={{
            width: this.props.pickerWidth || '100%',
            paddingBottom: paddingNeeded,
          }}
          onClick={this.handlePick}
        >
          {this.props.displayImage ? (
            <img src={this.props.displayImage} className={styles['image']} />
          ) : (
            <img src={browseToUpload} className={styles['imageOverlay']} />
          )}
        </div>
        <div id={this.props.elId} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/ImageUpload/index.js